import {ScrollArea} from 'alm-react-components';
import {useTranslation} from 'react-i18next';
import {defaultImage} from '../../../lib/utils';
import {useLayoutEffect} from 'react';
import PageLoader from '../../common/loader/PageLoader';

const LibraryWeekDetail = ({courseList, courseUpdate, courseId,notification}: any) => {
  const {t} = useTranslation();
  const handleCourseEnrollment = async (cardSelected: any, id: any) => {
    !cardSelected && courseUpdate(id);
  };
  useLayoutEffect(() => {
    const element = document.getElementById(`box-${courseId}`) as HTMLElement;
    if (element) {
      element.scrollIntoView();
      element.scrollIntoView(false);
      element.scrollIntoView({block: 'end'});
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });
    }
  }, [courseId]);

  const courseIdFromUrl = window.location.pathname.split('/')[4]
  return (
    <>{notification?<></>: courseList?.length ===0 && <PageLoader />} 
      {courseId && (
        <div className="" key={courseId}>
          <h4 className="font-light tracking-wider text-base font-barlowLight p-2 pb-3"></h4>
          <ScrollArea className="class-list-item-scroller">
            {courseList &&
              courseList?.map((course: any, index: number) => {
                const cardSelected = courseIdFromUrl == course?.id ? 'card-selected' : null;
                return (
                  <>
                    <div
                      key={index + '_' + course?.id}
                      onClick={() => {
                        handleCourseEnrollment(cardSelected, course?.id);
                      }}
                      id={`box-${course?.id}`}
                      className={`flex my-1 p-2 rounded-xl relative dark:text-gray-300 dark:hover:bg-fillMidGrayCard cursor-pointer dark:hover:text-white hover:bg-transparent ${cardSelected}`}
                    >
                      <div className="flex-none relative rounded-lg border mr-5 bg-fillMidGrayCard hover:opacity-100 hover:bg-black sm:w-[80px] sm:h-[54px] lg:w-[110px] lg:h-[72px] overflow-hidden max-sm:w-[110px] max-sm:h-[72px]">
                        {course?.imageUrl  ? (
                          <img
                            src={course?.imageUrl }
                            alt={(t('CourseDetails.fallbackText').replace(/<\/?[^>]+(>|$)/g, ""))}
                            className="w-full h-[inherit] object-cover bg-center lg:col-span-full"
                          />
                        )  : (
                          <img
                            src={defaultImage()}
                            alt={(t('CourseDetails.fallbackText').replace(/<\/?[^>]+(>|$)/g, ""))}
                            className="w-full h-[inherit] object-cover bg-center lg:col-span-full"
                          />
                        )}
                      </div>
                      <div className="flex flex-col w-full">
                        <p className="font-opensansSemiBold lg:text-base xl:text-lg">
                          {course?.name}
                        </p>
                      </div>
                    </div>
                  </>
                );
              })}
          </ScrollArea>
        </div>
      )}
    </>
  );
};

export default LibraryWeekDetail;
